import { render, staticRenderFns } from "./WorkFlo.vue?vue&type=template&id=8a623bc6&"
import script from "./WorkFlo.vue?vue&type=script&lang=js&"
export * from "./WorkFlo.vue?vue&type=script&lang=js&"
import style0 from "./WorkFlo.vue?vue&type=style&index=0&id=8a623bc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports